import { render } from "./OfferCall.vue?vue&type=template&id=67172b18"
import script from "./OfferCall.vue?vue&type=script&lang=js"
export * from "./OfferCall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__